import { Drawer, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/PesquisaPainelActions';
import reducer from './Store/Reducers/PesquisaPainelReducer';

const styles = theme => ({
    root: {
        width: '85%',
        "@media (min-width: 1280px)": {
            width: 500,
        }
    },
});

class PesquisaPainel extends XAPPComponent {

    constructor(props) {
        super(props);
        this.togglePainel = this._togglePainel.bind(this);
    }

    componentDidMount() {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }

    componentWillUnmount() {
        if (this.props.onRef) {
            this.props.onRef(undefined)
        }
    }

    _togglePainel = (_AID, _ACount, _AClear) => {
        this.props.togglePesquisa(_AID, _ACount, _AClear);
    }

    render() {
        const { classes, children, PesquisaPainel, anchor = "left", id } = this.props;
        return (
            <Drawer
                classes={{ paper: classes.root }}
                open={PesquisaPainel.open.includes(id)}
                anchor={anchor}
                onClose={() => this.togglePainel(id)}
            >
                <div className="flex">
                    <div className="flex-1" />
                    <XAPPButton
                        className=""
                        onClick={() => this.togglePainel(id)}
                        type="icon"
                        icon={"close"}
                        iconProps={"text-20"}
                    />
                </div>
                {children}
            </Drawer>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        togglePesquisa: Actions.togglePesquisa,
        closeAllPesquisa: Actions.closeAllPesquisa,
    }, dispatch);
}

function mapStateToProps({ PesquisaReducer }) {
    return {
        PesquisaPainel: PesquisaReducer,
    }
}

export default withReducer('PesquisaReducer', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PesquisaPainel))));
